import React, {PropsWithChildren} from 'react';
import {TrackingContextProvider} from './modules/TrackingContext';

export const AppContext = React.createContext(null);

export const AppContextProvider = ({children}: PropsWithChildren) => {
  return <TrackingContextProvider>{children}</TrackingContextProvider>;
};
